export default arr => {
  return arr.map(item => ({
    ...item,
    name: item.name.split('/').map(word => word.trim()).join(' / ')
  }));
};
